import { useState } from 'react';

// שמות כינוי — the other names a supplier goes by, 0–10 (server
// lib/supplierAliases.js). An upload whose printed name matches no supplier is
// linked to the one whose alias matches it AND whose ח.פ. matches the printed
// one, so the field only helps once the supplier's ח.פ. is filled in.
export const MAX_ALIASES = 10;

// `disabled` freezes the field while a change is being saved, so a second
// click cannot race the first. The input goes read-only rather than disabled
// so it keeps focus — the next nickname can be typed right after Enter.
export default function AliasesField({ value, onChange, disabled = false }) {
  const [draft, setDraft] = useState('');
  const full = value.length >= MAX_ALIASES;
  const add = () => {
    const alias = draft.trim();
    if (!alias || full || disabled) return;
    if (!value.some(v => v.trim().toLowerCase() === alias.toLowerCase())) onChange([...value, alias]);
    setDraft('');
  };
  return (
    <div className="form-group">
      <label>שמות כינוי <span style={{ fontWeight: 400, color: 'var(--ink-muted)' }}>({value.length}/{MAX_ALIASES})</span></label>
      {value.length > 0 && (
        <div className="alias-chips">
          {value.map(v => (
            <span key={v} className="alias-chip">
              {v}
              <button type="button" aria-label={`הסר את ${v}`} disabled={disabled} onClick={() => onChange(value.filter(x => x !== v))}>×</button>
            </span>
          ))}
        </div>
      )}
      <div style={{ display: 'flex', gap: 6 }}>
        <input className="form-control" value={draft} disabled={full} readOnly={disabled} aria-label="שם כינוי חדש"
          placeholder={full ? 'הגעת למקסימום של 10' : 'שם נוסף שמופיע על החשבוניות'}
          onChange={e => setDraft(e.target.value)}
          onKeyDown={e => { if (e.key === 'Enter') { e.preventDefault(); add(); } }} />
        <button type="button" className="btn btn-outline btn-sm" disabled={full || disabled || !draft.trim()} onClick={add}>הוסף</button>
      </div>
      <div style={{ fontSize: '0.78rem', marginTop: 4, color: 'var(--ink-muted)' }}>
        מסמך שהשם עליו הוא אחד מהכינויים, וגם הח.פ. עליו הוא של הספק — ישויך לספק הזה.
      </div>
    </div>
  );
}
